import React from 'react';
import { Link } from 'react-router-dom';
import classes from './unauthorized.module.scss';

export const Unauthorized = () => {

    return (
        <div className={classes.container}>
            <h1>Someone Been A Naughty Boy Eh?</h1>
            <Link to="/">Come, Lets go to church together</Link>
        </div>
    );
};
